
import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  inject,
  Provider,
  EnvironmentProviders,
} from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading, Router, withViewTransitions } from '@angular/router';
import { ViewTransitionService } from './services/view-transition.service';

import { routes } from './app.routes';
import { provideStore } from '@ngxs/store';
import { AuthState } from './modules/auth/state/auth.state';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import '@angular/common/locales/global/ru';
import { AppState } from './state/app.state';
import { AppFacade } from './state/app.facade';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';

const providers: Array<Provider | EnvironmentProviders> = [
  provideBrowserGlobalErrorListeners(),
  provideRouter(routes, withPreloading(PreloadAllModules), withViewTransitions({
    onViewTransitionCreated: ({ transition }) => inject(ViewTransitionService).notify(transition),
  })),
  provideNgxSkeletonLoader({
    theme: {
      extendsFromRoot: true,
    }
  }),
  {
    provide: LOCALE_ID,
    useValue: 'ru-RU'
  },
  provideHttpClient(
    withInterceptors([authInterceptor])
  ),
  provideAngularSvgIcon(),
  provideStore([AuthState, AppState]),
  AppFacade,
]

export const appConfig: ApplicationConfig = {
  providers,
};
